export var hasAncestor = function hasAncestor(target, ancestor) {
  return !!target && !!ancestor && ancestor.contains(target);
};
export var isOrphan = function isOrphan(target) {
  return typeof document === 'undefined' || !document.documentElement.contains(target);
};